import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyState } from '../reducers';

export const getUpdateTagState = createSelector(getDragonflyState, (state) => state?.editDate);

export const getColumn = createSelector(getUpdateTagState, (state) => state?.column);

export const getDate = createSelector(getUpdateTagState, (state) => state?.date);

export const getDateFormat = createSelector(getUpdateTagState, (state) => state?.dateFormat);

export const getShowEditDateButton = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tags.update') ? true : false,
);
